import { QueryState } from '@/common/enum';
import { Nullable } from 'interfaces/Nullable.ts';
import { IStationThreeAvailablePosts } from 'interfaces/admin.interface.ts';

export type StationStateTypes = {
  queryState: QueryState;
  selectedPostSetting: Nullable<IStationThreeAvailablePosts>;
  error: Nullable<string>;
};

export const StationInitialState: StationStateTypes = {
  queryState: QueryState.UNDEFINED,
  selectedPostSetting: null,
  error: null,
};
